import { io } from 'socket.io-client';
import { getToken } from './crypto';

let socket = null;

export function getSocket(token, deviceId) {
    if (socket) return socket;

    // Socket.IO base URL.
    //   - If REACT_APP_API_BASE is an absolute URL (e.g.
    //     https://api.example.com/api), strip the /api suffix and use
    //     that as the socket origin.
    //   - If it's a relative path (e.g. "/api" — what the new dev
    //     infra uses because CloudFront proxies /api/* AND /socket.io/*
    //     from the SPA origin to the ALB), use window.location.origin.
    //     Previously the empty-string result of stripping /api tripped
    //     the falsy guard below and getSocket() returned null — no
    //     connection ever attempted, and Redis-driven notifications
    //     never made it to the browser.
    const baseUrl = process.env.REACT_APP_API_BASE;
    const stripped = baseUrl?.replace(/\/api$/, '');
    const socketBase = stripped || (typeof window !== 'undefined' ? window.location.origin : '');

    if (!socketBase || !token) return null;

    socket = io(socketBase, {
        transports: ['websocket', 'polling'],
        auth: {
            token,
            deviceId,
        },
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
    });

    // Refresh auth token on each reconnect attempt so expired tokens don't block reconnection
    socket.on('reconnect_attempt', () => {
        const freshToken = getToken();
        if (freshToken) {
            socket.auth = { token: freshToken, deviceId };
        } else {
            // No token means user logged out — stop reconnecting
            socket.disconnect();
        }
    });

    return socket;
}

export function disconnectSocket() {
    if (socket) {
        socket.removeAllListeners();
        socket.disconnect();
        socket = null;
    }
}
